import { createFileRoute, redirect } from '@tanstack/react-router'

// Redirect `/listings` to home in beforeLoad — at the routing layer, before render, so
// there's no render-phase router update.
export const Route = createFileRoute('/_app/listings')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
